import React from 'react';
import {FieldValues} from 'react-hook-form';
import Form from 'shared/migration-components/form';
import TitleBar, {TitleBarProps} from 'shared/migration-components/title-bar';

import {Container} from './styles';
import {FormProps} from 'shared/migration-components/form';

interface CreationProps<T extends FieldValues> extends FormProps<T> {
  titleBar?: TitleBarProps;
}

const Creation: <T extends FieldValues>(
  P: CreationProps<T>,
) => React.ReactElement<T> = ({titleBar, ...props}) => {
  return (
    <Container>
      {titleBar && <TitleBar {...titleBar} />}
      <Form {...props} />
    </Container>
  );
};

export default Creation;
